/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Updated_ColInputs */

const en_admin_tickets_updated_col = /** @type {(inputs: Admin_Tickets_Updated_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Updated`)
};

const zh_admin_tickets_updated_col = /** @type {(inputs: Admin_Tickets_Updated_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新时间`)
};

/**
* | output |
* | --- |
* | "Last Updated" |
*
* @param {Admin_Tickets_Updated_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_updated_col = /** @type {((inputs?: Admin_Tickets_Updated_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Updated_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_updated_col(inputs)
	return zh_admin_tickets_updated_col(inputs)
});
export { admin_tickets_updated_col as "admin.tickets.updated_col" }